import React from "react"
import { Row, Col } from "@visa/vds"
import NumberedCircle from "../../../components/gettingstarted/NumberedCircle"

const AnsweredRow = (props) => {
    const {
        answer,
        question,
        questionId,
    } = props
    return (
        <>
            <Row className="getting-started-answered-row">
                <Col className="getting-started-question">
                    <Row className="width-max-content">
                        <NumberedCircle background="#E2F6D5" fontColor="black" number={questionId + 1} />
                        <span className="getting-started-question-label">{question.question}</span>

                    </Row>

                </Col>
                <Col className="getting-started-trailing-middle-dots-col">
                    <Row className="getting-started-middle-dots"></Row>
                    <Row className="getting-started-middle-invisible-dots"></Row>
                </Col>
                <Col class="getting-started-answer-col">
                    <Row className="getting-started-answer">
                        {answer.label}
                    </Row>
                </Col>
            </Row>
            <Row className="getting-started-answered-row-mobile">
                <Row className="width-max-content">
                    <NumberedCircle background="#E2F6D5" fontColor="black" number={questionId + 1} />
                    <span>{question.question}</span>

                </Row>

                <Row className="getting-started-answer padding-left-35px font-size-12px">
                    - {answer.label}
                </Row>
            </Row>
        </>
    )
}

export default AnsweredRow